import { adminHttpClient } from '../../commons/adminHttpClient'

export interface InviteEmployeesFormValues {
  notificationDate: string
}

const inviteEmployees = (values: InviteEmployeesFormValues): Promise<any> => {
  return adminHttpClient.post('/InvitePeople', values)
}

export default inviteEmployees
